module.exports = __webpack_public_path__ + "img/blankHorizons.e5267e80.svg";